<template>
  <div class="expand_conteiner">
    <CardWrapper
      caption="Neue Dokumente"
      v-bind:folder="folder"
      v-bind:barcode="barcode"
    />
    <CardWrapper
      caption="Fehlende Barcodes"
      v-bind:folder="folder"
      v-bind:barcode="barcode"
    />
  </div>
</template>

<script>
import CardWrapper from "./CardWrapper";
import { cliendDetail } from "../../_helper/apiserve";

export default {
  name: "Expand",
  data() {
    return {
      data: [],
      folder: [],
      barcode: [],
      container: Object
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {},
    async addtoFolder() {
      try {
        const res = await cliendDetail(
          this.row.clientIdData,
          localStorage.getItem("StartDate"),
          localStorage.getItem("EndDate")
        );
        const result = await res.json();

        this.data.push(result);
      } catch (e) {
        console.log("RES ERR  ==> ", e);
      }
      this.data.forEach(element => {
        this.folder = element.folder;
        this.barcode = element.barcode;
      });
    }
  },
  props: {
    row: Object,
    startDate: String,
    endDate: String
  },
  components: {
    CardWrapper
  },
  created() {
    this.$store.dispatch("addExpandAction", true);
    this.addtoFolder();
    // var tbody = document.querySelector(".dp-table-body .dp-table-overflowY");
    // var container = document.querySelector(".expand_conteiner");
    //tbody.scrollTo(0, container.scrollHeight);
  }
};
</script>

<style lang="scss">
@media only screen and (min-width: 600px) {
  .focused {
    width: 200px !important;
  }
}
@media only screen and (min-width: 768px) {
  .focused {
    width: 300px !important;
  }
}
@media only screen and (min-width: 900px) {
  .focused {
    width: 400px !important;
  }
}
@media only screen and (min-width: 1000px) {
  .focused {
    width: 500px !important;
  }
}
@media only screen and (min-width: 1130px) {
  .focused {
    width: 600px !important;
  }
}
@media only screen and (min-width: 1200px) {
  .focused {
    width: 750px !important;
  }
}

.expand_conteiner {
  overflow-y: scroll !important;
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 5px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #9b9b9b;
    border-radius: 5px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #9b9b9b;
  }
  max-height: 300px;
  height: auto !important;
  border-style: none !important;
  &:hover {
    background-color: #9b9b9b;
  }
}

.title {
  color: #174171;
  margin-left: 40px;
  font-weight: 600;
  font-size: 12px;
}
.value {
  padding-top: 11px;
  color: #4a4a4a;
  font-size: 17px;
}
.card {
  font-weight: 500;
  display: inline-block;
  width: 200px;
  height: 20px;
  color: #9b9b9b;
  font-size: 12px;
  border-radius: 4px;
  background: #f5f5f5;
  margin-right: 25px;
  margin-left: 40px;
  margin-bottom: 16px;
  align-items: center;
  text-align: center;
  padding: 40px;
}
</style>
